export const Locale = 'nl-BE';